var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4 border-bottom" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v(
                    "Actualizar usuario - " +
                      _vm._s(_vm.data.type) +
                      _vm._s(_vm.data.id)
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c(
                "div",
                { staticClass: "hstack gap-2 justify-content-end" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-h btn-dark px-3",
                      attrs: {
                        to: {
                          name: "UserDetail",
                          params: { role: _vm.role, id: _vm.id },
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "pe-2" }, [
                        _c("i", { staticClass: "bi bi-card-list" }),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Mostrar detalles")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-h btn-success px-3",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.UPDATE()
                        },
                      },
                    },
                    [
                      _vm.count == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status" },
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Loading..."),
                              ]),
                            ]
                          )
                        : _c("span", [_vm._v("Guardar cambios")]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bg-surface-secondary" },
          [
            _c(
              "v-tabs",
              {
                on: {
                  change: function ($event) {
                    return _vm.CHANGE()
                  },
                },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "account" }, [
                  _vm.errors.account_type ||
                  _vm.errors.company ||
                  _vm.errors.first_name ||
                  _vm.errors.last_name ||
                  _vm.errors.warehouse_id ||
                  _vm.errors.email ||
                  _vm.errors.username ||
                  _vm.errors.gender
                    ? _c("i", {
                        staticClass:
                          "fa-solid fa-circle-exclamation text-danger",
                      })
                    : _vm._e(),
                  _vm._v(" General"),
                ]),
                _vm._v(" "),
                _c("v-tab", { key: "notes" }, [
                  _vm.errors.phone ||
                  _vm.errors.deliver_to ||
                  _vm.errors.address ||
                  _vm.errors.country_id ||
                  _vm.errors.province_id ||
                  _vm.errors.city_id ||
                  _vm.errors.district_id ||
                  _vm.errors.branch_office_id
                    ? _c("i", {
                        staticClass:
                          "fa-solid fa-circle-exclamation text-danger",
                      })
                    : _vm._e(),
                  _vm._v(" Información de contacto"),
                ]),
                _vm._v(" "),
                _c("v-tab", { key: "fel" }, [
                  _vm.errors.fel ||
                  _vm.errors.identification_type ||
                  _vm.errors.identification ||
                  _vm.errors.email_fel ||
                  _vm.errors.activity_code_fel
                    ? _c("i", {
                        staticClass:
                          "fa-solid fa-circle-exclamation text-danger",
                      })
                    : _vm._e(),
                  _vm._v(" Facturación Electrónica"),
                ]),
                _vm._v(" "),
                _c("v-tab", { key: "security" }, [_vm._v("Seguridad")]),
                _vm._v(" "),
                _c("v-tab", { key: "more" }, [
                  _vm.errors.discount ||
                  _vm.errors.pin ||
                  _vm.errors.price_per_pound ||
                  _vm.errors.minimum_billable_amount
                    ? _c("i", {
                        staticClass:
                          "fa-solid fa-circle-exclamation text-danger",
                      })
                    : _vm._e(),
                  _vm._v(" Más"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid vstack gap-5" },
          [
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "account" },
                  [
                    _vm.tab == 0
                      ? _c("account", {
                          attrs: { data: _vm.data, errors: _vm.errors },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "notes" },
                  [
                    _vm.tab == 1
                      ? _c("contact", {
                          attrs: { data: _vm.data, errors: _vm.errors },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "fel" },
                  [
                    _vm.tab == 2
                      ? _c("fel", {
                          attrs: { data: _vm.data, errors: _vm.errors },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "security" },
                  [
                    _vm.tab == 3
                      ? _c("security", {
                          attrs: { data: _vm.data, errors: _vm.errors },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "more" },
                  [
                    _vm.tab == 4
                      ? _c("more", {
                          attrs: { data: _vm.data, errors: _vm.errors },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }